module.exports = __webpack_public_path__ + "static/media/dana_protection.ed3c9135.svg";